export const deg2rad = (deg: number) => deg * (Math.PI / 180);
